// @flow
/**
 * DEPRECATED
 * This component was built originally for uncontrolled forms but now we are moving towards
 * controlled forms because they are a more common React pattern. For more info check the link.
 * Alternative:
 * Use components in bench-internal-theme/form-input-fields. If this component doesn't exist, make a
 * copy and refactor so it can be used in a controlled form.
 * @link https://benchco.atlassian.net/browse/IN-2122?utm_medium=referral-external&utm_source=jira-slack&utm_term=
 */
import React, { Component } from 'react';
import styled from 'styled-components';
import Textarea from 'react-textarea-autosize';
import { colors } from 'bench-style-constants';

import Button from './Button';

const MessageInputLayout = styled.div`
  align-items: center;
  background: ${colors.white};
  border-radius: 2px;
  border: 1px solid ${colors.clay};
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: 1fr max-content;
  padding: 4px 4px 4px 8px;
`;

const StyledTextarea = styled(Textarea)`
  color: ${colors.charcoal};
  font-size: 12px;
  padding: 0;
  resize: none;
`;

type MessageInputBoxProps = {
  allowEmpty?: boolean,
  defaultValue?: string,
  onPost: (message: string) => Promise<any>,
  placeholder?: string,
  postButtonHeapId?: string,
};

type MessageInputBoxState = {
  value: string,
};

class MessageInputBox extends Component<MessageInputBoxProps, MessageInputBoxState> {
  static defaultProps = {
    allowEmpty: false,
    defaultValue: undefined,
    placeholder: undefined,
    postButtonHeapId: undefined,
  };

  constructor(props: MessageInputBoxProps) {
    super(props);
    const { defaultValue } = props;
    this.state = {
      value: defaultValue || '',
    };
  }

  isSaveDisabled() {
    if (this.state.value === this.props.defaultValue) {
      return true;
    }
    if (this.props.allowEmpty) {
      return false;
    }
    return this.state.value.length === 0;
  }

  handleFormSubmission = () => {
    if (!this.isSaveDisabled()) {
      this.props.onPost(this.state.value);
    }
  };

  render() {
    const { placeholder, postButtonHeapId } = this.props;
    const { value } = this.state;
    return (
      <MessageInputLayout>
        <StyledTextarea
          data-test-id="message-input-box-textarea"
          onChange={changeEvent => this.setState({ value: changeEvent.target.value })}
          placeholder={placeholder}
          value={value}
          onKeyDown={e => {
            if (e.metaKey && e.key === 'Enter') {
              this.handleFormSubmission();
            }
          }}
        />
        <Button
          data-test-id="message-input-box-button"
          data-heap-id={postButtonHeapId}
          size="small"
          styleType="primary"
          disabled={this.isSaveDisabled()}
          onClick={this.handleFormSubmission}
        >
          Save
        </Button>
      </MessageInputLayout>
    );
  }
}

export default MessageInputBox;
